import HomeI18n from './Home.i18n.js';
import {
  mapGetters,
  mapActions,
} from 'vuex'

export default {

  components: {},
  computed: {
    ...mapGetters(['featuredFamilles'])
  },
  props: {},

  data() {
    return {};
  },

  watch: {},

  methods: {
    ...mapActions(['getFeaturedFamilles']),
    /**
     * Got to family page.
     * @param {*} pFam 
     */
    goToFamily(pFam) {
      const catId = pFam.categorie_id
      const famId = pFam.id
      this.$router.push({
        path: `/categorie/${catId}/famille/${famId}`
      })
    },
    getPhotoLink(pPhotoLink) {
      return pPhotoLink + '?cacheKey=' + Date.now()
    },
    goToAPropos() {
      this.$router.push('apropos')
    },
  },

  mounted() {
    window.scrollTo(0, 0)
    this.getFeaturedFamilles()
  },

  i18n: HomeI18n,

};